import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Pricing from '../components/Pricing';
import PricingScroller from '../components/PricingScroller';


const PricingPage = () => {
    return (
        <>
            <Header />
            <Pricing />
            <Footer />
        </>
    )
}

export default PricingPage;